import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Service";
import Projects from "./components/Project";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/Floatbtn";
import Pricing from "./components/Pricing";

function App() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Pricing />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
